<template>
	<div class="container">
		<div class="news-detail">
			<div class="nd-body">
				<div class="bread-nav">
					<span @click="navgoTo()">全部</span> > 播聘新闻 > <span class="txt-gray">{{objData.title}}</span>
				</div>
				<div class="nd-body-content">
					<div class="nd-body-view">
						<div class="nd-body-view-title">{{objData.title}}</div>
						<div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 播聘新闻</div>
						<div class="nd-body-view-content">{{objData.content}}</div>
						<div class="nd-body-view-content">
							<img src="../../../static/news.png" alt="map"/>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitle}}</h3>
							<div>{{objData.contenta}}</div>
							<div>{{objData.contenta1}}</div>
							<div>{{objData.contenta2}}</div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
							<div>{{objData.contentb1}}</div>
							<div>{{objData.contentb2}}</div>
							<div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
							<div>{{objData.contentc1}}</div>
							<div>{{objData.contentc2}}</div>
							<div>{{objData.contentc3}}</div>
							<div>{{objData.contentc4}}</div>
						</div>
						<div class="nd-body-view-of">
							<div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
							<div>下一篇：{{objData.next}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'showNewsAge',
		data(){
			return {
				id:'',
				objData:{
					title:`【播聘观察】李克强说的“零工经济”到底是什么？`,
					date:`2019年9月12日`,
					froms:`播聘`,
					next:`播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
					prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
					content:`在国务院常务会议中，李克强总理强调了推动“分享经济”健康发展的重要性：分享经济利用“互联网+”，不仅创造了很多新业态，化解了不少过剩产能，更带动了大量就业。在雇用模式的转变上，人力市场也出现了“分享经济”的特征，总理随后谈到，他在南方某省考察期间发现，当地出现了改革开放初期曾有过的“零工市场”，工人们没有固定的雇主，而是按小时计算打零工，可能一天内服务好几家雇主。`,
					subtitle:`“零工经济”就是“打零工”吗？`,
					contenta:`笔者认为和字面意义的“打零工”有着不同的含义，“零工经济”的核心在于每个人都能够分享自己空闲的资源、特长，实现个体价值。并不是因为生存压力所迫而去当“零工”，出卖的是自己的体力劳动和压榨剩余时间。其它方面：不仅仅是代表雇员去主动为别人服务，还应该是可以让雇佣者（需求方）找上门，邀请其为他们服务。服务应该是多样化，才能更自由化，双方也能更平等。`,
					contenta1:`与此同时，调研数据显示，95后实际薪资大多数出现在3k-8k这个范畴，而期望薪资大多为8k-12k，对薪资的期待值普遍高于现状。这意味着，即使在经济下行的趋势下，95后仍未降低对薪资的预期。`,
					contenta2:`“零工经济”更偏向于提供服务者的知识、技能、经验这种无形的产品，并且需要向用户展现自己的价值、能力，虽然也需要付出时间和精力，但是在帮助别人解决问题的同时，更是获得了帮助他人的幸福感、尊严感，扩展了人脉、扩大了行业的交际圈。被服务者也能更能自主方便地选择多个服务者，打破了传统型固定某人，或者是需要长时间考查后才能决定 是否继续聘用其的现像。而现在我们可以节省更多的金钱，让每一分钱用在可以合适，有能力的雇佣者身上，不浪费在不该雇佣的人身上。`,

					subtitleb:`打破传统雇佣的新模式`,
					contentb1:`“零工经济”和自由职业者的崛起以及共享经济的发展密不可分。现代社会企业的边界逐渐变得不明确，不再由企业的内部员工完成企业的全部工作，传统的人力雇佣方式正在改变；共享经济下，个体的价值不断提升着，除了工作之外的剩余时间也在为社会贡献价值，甚至超过了他的本职工作。过去需依赖企业、公司才能完成的商业行为，现在个人完全有可能独立完成。`,
					contentb2:`“互联网+”的模式给了“零工经济”很大的表演舞台，原有的“企业——员工”雇佣合同制度逐渐向“平台——个人”的交易模式转变，使得对接更加快捷、报酬计算更加精细。`,

					subtitlec:`人人都可以参与“零工经济”`,
					contentc1:`“零工经济”下应运而生的各种互联网平台推出了各种短期兼职项目，几周几天都有，除了报酬可观，还能增长经验，不仅有各种兼职平台，比如：搜了么（SouLeMo.com）共享资源免费分享平台，本平台可以让需求方（雇主）与供给方（雇员）可以互相在线沟通聊天，需求方可以主动邀请供给方来为其服务；供给方可以主动去抢去接需求方发布的资源，平台提供了免费的担保平台，充分保证了资金的安全，真正做到服务完成后，被需求方（雇主、服务方）确认完成服务后，供给方才能真正拿到应有的报酬。双方真正做到了平等，放心，安心地交易模式。`,
					contentc2:`本人曾受朋友邀请，在“搜了么”平台上接了一个短期项目，在双方在平台上沟通，谈好合作方式和行程计划后，我利用周末一天（包括往返路程），帮助一家国企讲授海外投标文件制作的方法与相关技巧。笔者不单获得了报酬，交流结束后还和用户一起品尝了当地美食，并约好以后给他们做更高阶的培训。通过这次经历，笔者最近一直在思考：`,
					contentc3:`“零工经济”的实现方式更多样，无论是全职还是自由职业，还是介于两者之间的求职空档期，只要能够合理安排时间，愿意帮助别人，都可以从中获益。`,
					contentc4:`自由职业者们看重的是自由职业的灵活性，注重自我管理，他们是多家公司的独立顾问；移动平台、数字平台的蓬勃发展，给了全职工作族们利用碎片化时间打”零工“、实现个人价值的机会；若是处在焦虑和空虚的求职空档期，也可以尝试挑战时间短、形式灵活的小项目。`,
				}
			}
		},
		created(option) {
			this.init()
		},
		methods:{
			init(){
				let _this = this;
				_this.id = _this.$route.query.id || ``;
				
			},
			navgoTo(){
				this.$nav({path:`/show-news`},this)
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("./show-news-ling.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-news-ling/show-news-ling.vue